module.exports = __webpack_public_path__ + "roboto-latin-500-normal.48af7707fe9e6494d6a5f4aae1dea063.hashedasset.woff";